/**
 * common路由
 */
export default [
  {
    path: '/',
    meta: {
      title: '随享商城'
    },
    component: (resolve) => {
      require(['$views/index/index.vue'], resolve)
    }
  },
  {
    path: '/detail',
    meta: {
      title: '随享商城',
      containerClass: 'container',
    },
    component: (resolve) => {
      require(['$views/detail/index.vue'], resolve)
    },
  },
  {
    path: '/list',
    meta: {
      title: '随享商城列表'
    },
    component: (resolve) => {
      require(['$views/list/index.vue'], resolve)
    }
  },
  {
    path: '/explain',
    meta: {
      title: '售后保障说明'
    },
    component: (resolve) => {
      require(['$views/explain/index.vue'], resolve)
    }
  }
]



// WEBPACK FOOTER //
// ./src/routes/modules/common.js